import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Processamento } from '../processamento/processamento';

@Component({
  selector: 'app-processamento-periodo-selecionadas-table',
  templateUrl: './processamento-periodo-selecionadas-table.component.html',
  styleUrls: ['./processamento-periodo-selecionadas-table.component.scss'],
})
export class ProcessamentoPeriodoSelecionadasTableComponent implements AfterViewInit {
  public readonly pageSizeOptions = [10, 20, 50];
  public readonly pageSizeDefault = 10;
  public readonly displayedColumns: string[] = ['processamentosSelecionados'];

  @Input() processamentosSelecionados: Processamento[] = [];

  dataSource!: MatTableDataSource<Processamento>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource<Processamento>(this.processamentosSelecionados);
    this.dataSource.paginator = this.paginator;
  }
}
